type GraphQLResponse = {
  errors?: unknown[];
  data?: Record<string, unknown>;
};

/**
 * Returns GraphQL errors when the transport succeeded but the payload
 * contains field-level failures.
 */
export function getGraphQLErrors(
  res: GraphQLResponse | null | undefined
): unknown[] | null {
  if (Array.isArray(res?.errors) && res.errors.length > 0) {
    return res.errors;
  }
  return null;
}

/**
 * Opt-in Apollo cache invalidation. Mutations no longer wipe the entire cache
 * by default — callers that change auth/cart state pass `invalidateCache: true`.
 */
export function shouldInvalidateApolloCache(
  options?: { invalidateCache?: boolean } | null
): boolean {
  return options?.invalidateCache === true;
}
